// Same rule as `@koob/ui`'s `clampDepartureDate` (features/tripWizard/
// buildTripPayload.ts), duplicated rather than imported: that file's own
// sibling `types.ts` imports `@koob/ui/src/components`'s full barrel, which
// would pull every pre-existing, unrelated @koob/ui type error into this
// package's own `tsc --noEmit` (that package is skipped by
// `scripts/typecheck.js`, but only when checked directly).
function todayNoon(): Date {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  return d;
}

function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function isInvalidDepartureDate(date: Date | null | undefined): boolean {
  return (
    !date ||
    isNaN(date.getTime()) ||
    startOfDay(date).getTime() < startOfDay(new Date()).getTime()
  );
}

/**
 * A departure date the API would refuse (null, invalid, or before today) is
 * replaced by today at noon; a valid future date passes through untouched.
 */
export function clampDepartureDate(date: Date | null | undefined): Date {
  return isInvalidDepartureDate(date) ? todayNoon() : (date as Date);
}
